module.exports = __webpack_public_path__ + "static/media/miysis_3d_notre_dame_animation_WL.48070297.mp4";